<template>
  <b-form-group>
    <v-select
      :disabled="loading"
      :id="id"
      :label="label"
      :options="data"
      :placeholder="placeholder"
      :reduce="(option) => option[id]"
      v-model="computedValue"
      @search="onFilterData"
    >
      <template slot="no-options">
        {{ placeholder }}
      </template>
    </v-select>
  </b-form-group>
</template>

<script>
export default {
  name: 'input-selector',
  props: ['data', 'id', 'label', 'loading', 'placeholder', 'value'],
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    onFilterData(v, loading) {},
  },
  watch: {
    computedValue(nv) {
      this.$emit('onChangeSelector', nv);
    },
  },
};
</script>

<style scoped></style>
